const currencies = { EUR: "€", USD: "$" };

export const displayCurrency = currency => currencies[currency] || "€";

export const displayFloatAmount = amount => {
  return parseFloat(amount).toFixed(2);
};
